var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationRole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48602",
    "data-name": "Group 48602",
    transform: "translate(-1191 -676)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138035",
    "data-name": "Rectangle 138035",
    width: 24,
    height: 24,
    transform: "translate(1191 676)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48569",
    "data-name": "Group 48569",
    transform: "translate(-67.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93213",
    "data-name": "Path 93213",
    d: "M4.171,3.916,2.2,5.207a3.186,3.186,0,0,0,0,5.343l6.024,3.933a3.914,3.914,0,0,0,3.942,0L18.16,10.55a3.188,3.188,0,0,0,0-5.333L12.166,1.283a3.914,3.914,0,0,0-3.942,0Z",
    transform: "translate(1261 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.501
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93214",
    "data-name": "Path 93214",
    d: "M3.8,11.83l-.01,4.693a3.415,3.415,0,0,0,2.181,3.032l3.192,1.06a3.833,3.833,0,0,0,2.022,0l3.192-1.06a3.415,3.415,0,0,0,2.181-3.032V11.88",
    transform: "translate(1261 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.501
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    y1: 6.004,
    transform: "translate(1280.58 688.747)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.501
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationRole);
export default __webpack_public_path__ + "static/media/education-role.02688ab9e56941dea2229cc7b88fd86b.svg";
export { ForwardRef as ReactComponent };